export default __webpack_public_path__ + "static/media/logo2.c96547a9.png";